import React from 'react';

export const CarrierContext = React.createContext([]);
export const CategoryContext = React.createContext([]);
export const RequestContext = React.createContext([]);
export const TrailerLocationContext = React.createContext<any[]>([]);
